module.exports = __webpack_public_path__ + "static/img/logo1.71c5ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moneyStage/logo1.png
// module id = on9J
// module chunks = 44